<template>
  <section class="compare-list-container">
    <div v-for="(surveySession, index) of filteredSurveySessions" :key="index">
      <strong>{{ surveySession.Name }}</strong>
      <ul class="compareList">
        <li v-for="survey of surveySession.surveys" :key="survey.sessionId">
          <div>
            <input type="radio" name="sessionId" :id="survey.sessionId" :value="survey.sessionId" @change="onSessionSelected(survey.sessionId)" />
          </div>
          <label :for="survey.sessionId">
            <template v-if="survey.lastUpdatedAt">
              <strong>{{ convertDate(survey.lastUpdatedAt) }}</strong>
            </template>
            <template v-else>-</template>
            <p>
              <span class="badge">{{ $t("survey." + survey.namespace) }}</span> - {{ survey.username }}
            </p>
          </label>
        </li>
      </ul>
  </div>
  </section>
</template>

<script>
import { format } from 'date-fns';

export default {
  name: 'CompareList',
  props: ['surveySessions', 'namespace', 'surveySessionId'],
  computed: {
    filteredSurveySessions() {
      return this.surveySessions
        .map((surveySession) => ({
          ...surveySession,
          surveys: surveySession.surveys.filter((survey) => survey.namespace === this.namespace && survey.sessionId !== this.surveySessionId && survey.status === 'Completed'),
        }))
        .filter((surveySession) => surveySession.surveys?.length > 0);
    },
  },
  methods: {
    convertDate(d) {
      let date;
      if (d) {
        date = format(new Date(d), 'dd/MM/yyyy HH:mm');
        return date;
      }
      return date;
    },
    onSessionSelected(sessionId) {
      this.$emit('change', sessionId);
    },
  },
};
</script>

<style>
.compareList li {
  display: flex;
  flex-direction: row;
  border: 5px solid #EEEEEE;
}
.compareList li div {
  width: 50px;
  display: flex;
  justify-content: center;
  background-color: #EEEEEE;
}
.compareList li div input {
  cursor: pointer;
  width: 18.5px;
}
.compareList p {
  margin: 0;
}
.compareList label {
  cursor: pointer;
  padding: 10px;
  width: 100%;
  user-select: none;
}
.compare-list-container {
  max-height: 50vh;
  overflow: auto;
  padding-bottom: 5em;
}
</style>
